import InvestmentGreySvg from '../../../assets/icons/investment-grey.svg';
import InvestmentBurgundySvg from '../../../assets/icons/investment-burgundy.svg';
import ExploreGreySvg from '../../../assets/icons/explore.svg';
import ExploreBurgundySvg from '../../../assets/icons/explore-burgundy.svg';
import FolioGreySvg from '../../../assets/icons/folio.svg';
import FolioBurgundySvg from '../../../assets/icons/folio-burgundy.svg';
import QuickAccessGreySvg from '../../../assets/icons/quick-access-grey.svg';
import QuickAccessBurgundySvg from '../../../assets/icons/quick-access-burgundy.svg';
import FAQSvg from '../../../assets/icons/faq.svg';
import FAQBurgundySvg from '../../../assets/icons/faq-burgundy.svg';
import NotificationSvg from '../../../assets/icons/notification.svg';
import MyProfileSvg from '../../../assets/icons/my-profile-new.svg';
import MyProfileBurgundySvg from '../../../assets/icons/my-profile-burgundy.svg';
import UserGuideSvg from '../../../assets/icons/investigation.svg';
import CartSvg from '../../../assets/icons/cart.svg';
import CartGreySvg from '../../../assets/icons/cart-grey.svg';
import LoanAaginstMFSvg from '../../../assets/icons/lamf.svg';


export const getIconForNavigationTab = (iconName) => {
  switch (iconName) {
    case 'InvestmentGreySvg':
      return <InvestmentGreySvg />;
    case 'InvestmentBurgundySvg':
      return <InvestmentBurgundySvg />;
    case 'ExploreGreySvg':
      return <ExploreGreySvg />;
    case 'ExploreBurgundySvg':
      return <ExploreBurgundySvg />;
    case 'FolioGreySvg':
      return <FolioGreySvg />;
    case 'FolioBurgundySvg':
      return <FolioBurgundySvg />;
    case 'QuickAccessGreySvg':
      return <QuickAccessGreySvg />;
    case 'QuickAccessBurgundySvg':
      return <QuickAccessBurgundySvg />;
    case 'FAQSvg':
      return <FAQSvg />;
    case 'FAQBurgundySvg':
      return <FAQBurgundySvg />;
    case 'NotificationSvg':
      return <NotificationSvg />;
    case 'MyProfileSvg':
      return <MyProfileSvg />;
    case 'MyProfileBurgundySvg':
      return <MyProfileBurgundySvg />;
    case 'UserGuideSvg':
      return <UserGuideSvg />
    case 'CartSvg':
      return <CartSvg />;
    case 'CartGreySvg':
      return <CartGreySvg />;
    case 'LoanAaginstMFSvg':
      return <LoanAaginstMFSvg />;
    default:
      return <InvestmentGreySvg />;
  }
};
